module.exports = __webpack_public_path__ + "static/img/编组 3@2x.1f8e0bdb.png";